// Click-outside-to-close for every modal. A click that lands directly on a
// modal's backdrop (not on the card inside it) reuses that modal's own close
// button so existing close animations / state cleanup still run. Falls back to
// hiding the overlay if it has no close control.
//
// Opt out per modal with data-no-backdrop-close (used on flows where an
// accidental dismissal would lose something, e.g. one-time recovery codes).
// Importing this module self-initializes the listener.

const BACKDROPS =
  ".modal-backdrop, .modal-overlay, .modal-overlay-form, .item-modal-overlay, .edit-modal-overlay";

const CLOSE_CONTROLS = [
  ".modal-close",
  ".modal-close-btn",
  ".edit-modal-close",
  ".item-modal-close",
  ".pos-close-btn",
  ".all-orders-modal-close",
  ".rp-list-modal-close",
  ".sale-receipt-close",
  ".support-topbar-close",
  ".pb-lightbox-close",
].join(", ");

document.addEventListener("click", (e) => {
  const overlay = e.target;
  // Only a direct hit on the backdrop itself - clicks inside the card have the
  // card (or its children) as the target and are ignored.
  if (!(overlay instanceof HTMLElement) || !overlay.matches(BACKDROPS)) return;
  if (overlay.hasAttribute("data-no-backdrop-close")) return;

  const closeBtn = overlay.querySelector(CLOSE_CONTROLS);
  if (closeBtn) closeBtn.click();
  else overlay.classList.add("hidden");
});
